import React, { useContext } from "react";
import { IMAGES } from "../../assets";
import ProgressBar from "../ProgressBar";
import { STRINGS } from "../../constants";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { AuthContext } from "../../context";
import { FILE_URL } from "../../constants/Constants";
import Proptypes from "prop-types";

const BookCard = ({
  img,
  name,
  price,
  rating,
  type,
  isProgerss,
  isCartBtn,
  onClick,
  percentage,
}) => {
  BookCard.propTypes = {
    img: Proptypes.array,
    name: Proptypes.string.isRequired,
    price: Proptypes.string,
    rating: Proptypes.number,
    type: Proptypes.any,
    isProgerss: Proptypes.bool,
    isCartBtn: Proptypes.any,
    onClick: Proptypes.any,
    percentage: Proptypes.any,
  };
  const { t } = useTranslation();
  const { activeLanguage } = useContext(AuthContext);

  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    cssEase: "linear",
  };

  return (
    <>
      {type === "horizontal" ? (
        <button onClick={onClick} className="cursor-pointer w-full">
          <div className="border bg-white w-full border-slate-200 rounded-md py-2 px-4 flex flex-wrap items-center gap-3 mt-2">
            <div className="grid grid-cols-12 items-center justify-between gap-3 w-full">
              <div className="col-span-4">
                <div className="h-32 w-20 border-2 rounded-xl">
                  {typeof img === "object" && img?.length >= 1 && (
                    <img
                      className="h-full w-full object-cover rounded-xl"
                      src={img[0] ? `${FILE_URL}${img[0]}` : IMAGES?.logo}
                      // src={img[0] ?? IMAGES?.logo}
                      alt="book cover"
                    />
                  )}

                  {typeof img === "string" && (
                    <img
                      className="h-full w-full object-cover rounded-xl"
                      src={img ? `${FILE_URL}${img}` : IMAGES?.logo}
                      // src={img ?? IMAGES?.logo}
                      alt="book cover"
                    />
                  )}
                </div>
              </div>

              <div className=" col-span-8 flex flex-col md:flex-row items-baseline justify-between w-full">
                <div className="w-full md:w-70">
                  <h2 className="text-base font-medium">{name}</h2>
                  <span className="text-sm font-medium text-[#545454]">
                    {price}
                  </span>
                  {isProgerss && (
                    <div>
                      <ProgressBar percentage={percentage} color="#480D9B" />

                      {activeLanguage === "Marathi" ? (
                        <span className="text-xs font-normal text-[#333333]">
                          {percentage > 0
                            ? new Intl.NumberFormat("mr", {
                                maximumSignificantDigits: 2,
                              }).format(percentage) +
                              " % " +
                              t(STRINGS?.completed)
                            : t(STRINGS?.not_yet_started)}
                        </span>
                      ) : (
                        <span className="text-xs font-normal text-[#333333]">
                          {percentage > 0
                            ? new Intl.NumberFormat("en", {
                                maximumSignificantDigits: 2,
                              }).format(percentage) +
                              " % " +
                              t(STRINGS?.completed)
                            : t(STRINGS?.not_yet_started)}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                <div className="text-sm flex items-center justify-center gap-1">
                  <img alt="staricon" className="h-4" src={IMAGES?.starIcon} />
                  {activeLanguage === "Marathi" ? (
                    <span>
                      {typeof rating === "number"
                        ? new Intl.NumberFormat("mr", {
                            maximumSignificantDigits: 2,
                          }).format((rating * 5) / 100)
                        : 0}
                    </span>
                  ) : (
                    <span className="text-[#545454]">
                      {typeof rating === "number"
                        ? ((rating * 5) / 100).toFixed(1)
                        : 0}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </button>
      ) : (
        <div className="cursor-pointer " onClick={onClick}>
          <div className=" relative min-h-[280px]  m-4 rounded-md px-2 py-4 flex flex-col items-center gap-3 bg-white">
            <div className="h-48 w-32  rounded-xl overflow-hidden">
              <Slider arrows={false} {...settings}>
                {img?.length > 1 &&
                  img?.map((ele) => (
                    <img
                      key={ele}
                      className="h-full w-full object-cover rounded-xl border-2"
                      src={ele ? `${FILE_URL}${ele}` : IMAGES?.logo}
                      alt="book cover"
                    />
                  ))}
              </Slider>

              {typeof img === "object" &&
                img?.length === 1 &&
                img?.map((ele) => (
                  <img
                    key={ele}
                    className="h-full w-full object-cover rounded-xl border-2"
                    src={ele ? `${FILE_URL}${ele}` : IMAGES?.logo}
                    alt="book cover"
                  />
                ))}

              {typeof img === "string" && (
                <img
                  className="h-full w-full object-cover rounded-xl border-2"
                  src={img ? `${FILE_URL}${img}` : IMAGES?.logo}
                  alt="book cover"
                />
              )}
            </div>

            <div className="flex flex-col items-start justify-center gap-2 relative w-full">
              <div className="w-full flex items-center gap-2">
                <h2
                  className="text-base font-bold truncate overflow-hidden"
                  title={name}
                >
                  {name}
                </h2>

                <div className="text-sm flex items-center justify-center gap-1">
                  <img alt="staricon" className="h-4 " src={IMAGES?.starIcon} />
                  {activeLanguage === "Marathi" ? (
                    <span>
                      {typeof rating === "number"
                        ? new Intl.NumberFormat("mr", {
                            maximumSignificantDigits: 2,
                          }).format((rating * 5) / 100)
                        : 0}
                    </span>
                  ) : (
                    <span className="text-[#545454]">
                      {typeof rating === "number"
                        ? ((rating * 5) / 100).toFixed(1)
                        : 0}
                    </span>
                  )}
                </div>
              </div>
              {isCartBtn && <span className="text-sm font-normal">{name}</span>}
              <div className="flex items-center justify-between w-full">
                <span className="text-sm font-medium text-[#545454]">
                  {price}
                </span>
                {isCartBtn && (
                  <button className="text-sm text-white px-2 py-1 bg-[#FE6B01] rounded-md">
                    Add To cart
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default BookCard;
